
import { Modal, Form, Input, Upload, Button, Avatar } from 'antd';
import { UploadOutlined, UserOutlined } from '@ant-design/icons';
import { useGlobalState } from '../hooks/useGlobalState';
import { updateSysUser } from '../services/userService';
import { whoami } from '../services/auth.js';
import { getAvatarSignedUrl, uploadToS3, getUserAvatar } from '../services/uploadFile.js';
import { notification } from 'antd';
function PersonalCenter({ open, onClose }) {

    const [form] = Form.useForm();
    const { userProfile, updateUserProfile } = useGlobalState();

    const handleFileUpload = async fileInfo => {
        const { file } = fileInfo;
        try {
            const url = await getAvatarSignedUrl(userProfile?.user?.userId);
            await uploadToS3(url, file);
            notification.success({ message: 'Upload successfully' });
            const newAvatarUrl = await getUserAvatar(userProfile?.user?.userId);
            updateUserProfile({
                user: {
                    ...userProfile?.user,
                    avatar: `${newAvatarUrl}?t=${new Date().getTime()}`
                }
            })
        } catch (error) {
            notification.error({ message: error.message });
        }
    };

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            updateSysUser({
                userId: userProfile?.user?.userId,
                name: values.name,
            }).then(res => {
                if (res.code === 200) {
                    whoami().then((res) => {
                        if (res !== null) {
                            updateUserProfile(res);
                        }
                    })
                    onClose();
                }
            }).catch(err => {
                console.log('更新用户姓名失败', err);
            })
        });
    };

    return (
        <Modal
            title="User Info"
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Save
                </Button>,
            ]}
            centered
        >
            <div style={{ textAlign: 'center', marginBottom: 14 }}>
                <Avatar
                    size={100}
                     src={userProfile?.user?.avatar ? `${userProfile?.user?.avatar}?t=${new Date().getTime()}` : undefined}
                    icon={<UserOutlined />}
                />
            </div>
            <div style={{ textAlign: 'center', marginBottom: 14 }}>

                <Upload showUploadList={false} customRequest={handleFileUpload}>
                    <Button icon={<UploadOutlined />}>Upload Avatar</Button>
                </Upload>
            </div>
            <Form
                form={form}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                initialValues={{
                    email: userProfile?.user?.userName || '',
                    name: userProfile?.user?.nickName || '',
                }}
            >
                <Form.Item label="Email:" name="email">
                    <Input disabled />
                </Form.Item>

                <Form.Item
                    label="Name:"
                    name="name"
                    rules={[{ required: true, message: 'Please input your name' }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default PersonalCenter;
